import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { format, parse } from 'date-fns'

export const DATE_FORMAT = 'yyyy-MM-dd'
export const SFI_DATE_INPUT_FORMAT = 'd.M.yyyy'
const UI_DATE_FORMAT = 'd.M.yyyy'
const PRINT_DATE_FORMAT = 'dd.MM.yyyy'
const UI_TIME_FORMAT = `HH:mm`

/**
 *
 * @param dateString date in DATE_FORMAT ('yyyy-MM-dd') string format
 * @returns date string in UI_DATE_FORMAT ('d.M.yyyy') format
 */
export const formatDateFormatToUiDateFormat = (dateString: string): string => {
  return format(parse(dateString, DATE_FORMAT, new Date()), UI_DATE_FORMAT)
}

/**
 * @returns date string in UI_DATE_FORMAT ('d.M.yyyy') format
 */
export const formatDateToUiDateFormat = (date: Date): string => {
  return format(date, UI_DATE_FORMAT)
}

/**
 * @return time string in UI_DATE_FORMAT ('HH:mm') format
 */
export const formatDateToUiTimeFormat = (date: Date): string => {
  return format(date, UI_TIME_FORMAT)
}

/**
 * @returns date string in DATE_FORMAT ('yyyy-MM-dd') format
 */
export const formatDateToDateFormat = (date: Date): string => {
  return format(date, DATE_FORMAT)
}

/**
 * @returns date string in PRINT_DATE_FORMAT ('dd.MM.yyyy') format
 */
export const formatDateToPrintDateFormat = (date: Date): string => {
  return format(date, PRINT_DATE_FORMAT)
}

export const formatDateToPrintDateLocaleFormat = (
  date: Date,
  language: LanguageCode.FI | LanguageCode.EN | LanguageCode.SV
): string => {
  switch (language) {
    case LanguageCode.EN:
      return format(date, 'd MMM y')
    case LanguageCode.FI:
    case LanguageCode.SV:
      return formatDateToPrintDateFormat(date)
    default:
      const value: never = language
      throw new Error(`Exhaustive type check failed for value: ${value}`)
  }
}
